import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { tableCell } from './DataCell/DataCell.tokens.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var TableBase = styled.table.withConfig({
  displayName: "Table__TableBase",
  componentId: "sc-14kktwc-0"
})(["border-spacing:0;background:", ";"], tableCell.background);
var Table = /*#__PURE__*/forwardRef(function Table(_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(TableBase, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    children: children
  }));
});

// Table.displayName = 'EdsTable'

export { Table };
